import { Injectable } from '@angular/core';
import { RensComplementairesDivers } from '../../models/RensComplementairesDivers';
import { ChampLibreGroup } from '../../models/ChampLibreGroup';

@Injectable({
  providedIn: 'root'
})
export class RensCompltService {

  constructor() {
  }

  public getRensComplt(controls, formExtractorService): RensComplementairesDivers {
    const rensComplt = new RensComplementairesDivers();
    rensComplt.txtLibre = new ChampLibreGroup();
    rensComplt.txtLibre.champsLibre = controls.get('_SepSep_TypeAnn_DIVER_G1_SepSep_Description_SepAtt_champsLibre');
    rensComplt.intLibre.intituleLibre = this.sanitizeString(controls.get('_SepSep_TypeAnn_DIVER_G1_SepSep_rens_compl_SepAtt_intituleLibre'));
    rensComplt.intLibre.intituleLibreLibelle = this.sanitizeString(controls.get('_SepSep_TypeAnn_DIVER_G1_SepSep_rens_compl_SepAtt_intituleLibreLibelle'));
    return rensComplt;
  }

  private sanitizeString(value: any): string | null {
    if (typeof value !== 'string') {
      return value;
    }
    const trimmed = value.trim();
    return trimmed.length > 0 ? trimmed : null;
  }
}
